
export class GC_Valid_T_RegExp {

    protected regexList;

    constructor(regex) {
        if (!Array.isArray(regex)) {
            regex = [regex];
        }
        this.regexList = regex;
    }

    public validate(variable) {
        let ok = true;
        let idx, objRegEx;
        for (idx = 0; idx < this.regexList.length; idx++) {
            if (!ok) {break;}
            objRegEx = null;
            objRegEx = new RegExp(this.regexList[idx]);
            ok = objRegEx.test(variable);
        }
        return ok;
    }

}
